import { MainNav } from './globalNav/a11yFunctions';
import { clearMenuFilter, setupMenuFilter } from './globalNav/menuFilter';

class GlobalNav {
  constructor(globalNavElement) {
    this.globalNavElement = globalNavElement;

    this.mainNavOffCanvas = globalNavElement.querySelector('#main-nav');
    this.menuButton = globalNavElement.querySelector('.navbar-toggle');
    this.backdrop = globalNavElement.querySelector('.menu-page-backdrop');

    this.mainMenuOffcanvasBs = window?.bootstrap?.Offcanvas.getInstance(this.mainNavOffCanvas);
    this.megaMenu = new MainNav(this.mainNavOffCanvas);
    this.level2Menus = Object.values(this.megaMenu.menus).filter((menu) => menu.menuType === 'level2Menu');
    this.level3Menus = Object.values(this.megaMenu.menus).filter((menu) => menu.menuType === 'level3Menu');
    this.initializeEventListeners();
  }

  initializeEventListeners() {
    this.mainNavOffCanvas.addEventListener('show.bs.offcanvas', this.handleMainNavShow.bind(this));
    this.mainNavOffCanvas.addEventListener('hide.bs.offcanvas', this.handleMainNavHide.bind(this));
    this.mainNavOffCanvas.addEventListener('hidden.bs.offcanvas', () => {
      this.menuButton.focus();
    });
    Object.keys(this.megaMenu.menus).forEach((menu) => {
      const menuObj = this.megaMenu.menus[menu];
      switch (menuObj.menuType) {
        case 'main-menu':
          menuObj.navItems.forEach((item) => {
            if (item.element.tagName === 'BUTTON') {
              item.element.classList.contains('menu-close-btn')
                ? item.element.addEventListener('click', this.handleCloseBtnClick.bind(this))
                : item.element.addEventListener('click', () => this.handleDropDownButtonClick(item.element));
            }
          });
          break;

        case 'level2Menu':
          menuObj.navItems.forEach((item) => {
            if (item.element.tagName === 'BUTTON') {
              item.element.classList.contains('menu-close-btn')
                ? item.element.addEventListener('click', () => {
                    this.handleLevel2CloseBtnClick(menuObj).then(() => {
                      menuObj.menuElement.classList.remove('visible');
                    });
                  })
                : item.element.classList.contains('menu-back-btn')
                ? item.element.addEventListener('click', (e) => this.handleBackButtonClick(e, menuObj))
                : item.element.classList.contains('menu-cta-btn')
                ? null
                : item.element.addEventListener(
                    'click',
                    async () =>
                      await this.handleLevel2MenuButtonClick(
                        item.element,
                        this.megaMenu.menus[item.controls].menuElement,
                        menuObj
                      )
                  );
              menuObj.menuElement.addEventListener('keydown', (e) => {
                if (e.code === 'Escape')
                  this.handleLevel2CloseBtnClick(menuObj).then(() => {
                    menuObj.menuElement.classList.remove('visible');
                  });
              });
            }
          });
          break;

        case 'level3Menu':
          setupMenuFilter(this.globalNavElement, menuObj.menuElement);
          menuObj.navItems.forEach((item) => {
            if (item.element.tagName === 'BUTTON') {
              if (item.element.classList.contains('menu-close-btn')) {
                item.element.addEventListener('click', async () => this.handleLevel3CloseBtnClick(menuObj));
              } else if (item.element.classList.contains('menu-back-btn')) {
                item.element.addEventListener('click', (e) => this.handleBackButtonClick(e, menuObj));
              }
            }
          });
          menuObj.menuElement.addEventListener('keydown', async (e) => {
            if (e.code === 'Escape') await this.handleLevel3CloseBtnClick(menuObj);
          });
          break;
      }
    });
    this.backdrop.addEventListener('click', this.handleBackdropClick.bind(this));
  }

  handleBackdropClick() {
    this.hideSubMenus();
    this.hideMenuBackdrop();
  }

  showMenuBackdrop() {
    if (!this.backdrop.classList.contains('show')) {
      this.backdrop.classList.add('show');
    }
  }

  hideMenuBackdrop() {
    if (this.backdrop.classList.contains('show')) {
      this.backdrop.classList.remove('show');
    }
  }

  handleMainNavShow() {
    this.mainMenuOffcanvasBs = window.bootstrap.Offcanvas.getInstance(this.mainNavOffCanvas);
    // this.backdrop.classList.add('show');
  }
  handleMainNavHide() {
    this.hideSubMenus();
    // this.backdrop.classList.remove('show');
  }

  handleCloseBtnClick() {
    if (this.mainMenuOffcanvasBs) {
      this.mainMenuOffcanvasBs.hide();
    }
    this.hideMenuBackdrop();
    document.body.style.overflow = '';
    Object.keys(this.megaMenu.menus).forEach((menuId) => {
      this.megaMenu.menus[menuId].resetMenu();
    });
  }

  async handleLevel3CloseBtnClick(menu) {
    this.hideSubMenus();
    this.handleCloseBtnClick();
    await this.delay(200);
    this.megaMenu.menus['main-nav'].navItems.forEach((item) => {
      if (item.controls === menu.menuId.split('-')[0]) {
        item.element.focus();
      }
    });
  }

  async handleLevel2CloseBtnClick(menu) {
    this.hideSubMenus();
    this.handleCloseBtnClick();
    menu.focusTrap.deactivate();
    await this.delay(200);
    this.megaMenu.menus['main-nav'].navItems.forEach((item) => {
      if (item.controls === menu.menuId) {
        item.element.focus();
      }
    });
  }

  async handleBackButtonClick(e, menuObj) {
    const menu = menuObj.menuElement;
    const parentMenuId = menuObj.menuType === 'level2Menu' ? 'main-nav' : e.target.getAttribute('data-parent-menu-id');
    const parentMenu = this.megaMenu.menus[parentMenuId];
    const parentBtn = parentMenu.navItems.find((item) => item.controls === menu.id).element;
    menu.classList.remove('show');
    menuObj.resetMenu();
    await this.delay(200);
    menu.classList.remove('visible');
    parentBtn.focus();
  }

  handleDropDownButtonClick(btn) {
    if (window.micrositeNav) {
      window.micrositeNav.resetAllMicrositeMenus();
    }
    const menu = btn.nextElementSibling;
    if (!menu.classList.contains('show')) {
      this.showMenuBackdrop();
      menu.classList.add('visible');
      // want to make sure the backdrop is not scrollable when the menu is open
      document.body.style.overflow = 'hidden';
      menu.classList.add('show');
      menu.querySelector('.menu-close-btn').focus();
      this.megaMenu.menus[menu.id].focusTrap.activate();
    }
  }

  hideAllLevel3Menus() {
    this.level3Menus.forEach((menu) => {
      if (menu.menuElement.classList.contains('show')) {
        menu.menuElement.classList.remove('show');
        menu.menuElement.previousElementSibling.setAttribute('aria-expanded', 'false');
        clearMenuFilter(menu.menuElement, this.globalNavElement);
        menu.resetMenu();
        setTimeout(() => {
          menu.menuElement.classList.remove('visible');
          menu.menuElement.classList.add('d-none');
        }, 200);
      }
    });
  }

  async handleLevel2MenuButtonClick(menuButton, menu, menuObj) {
    const parentUl = Array.from(menuObj.menuElement.children).find((child) => child.tagName === 'UL');
    if (!menu.classList.contains('show')) {
      parentUl.classList.remove('overflow-scroll');
      menu.classList.remove('d-none');
      menu.style.top = `-${menuButton.parentElement.getBoundingClientRect().top}px`;
      // This little bit keeps the menu from getting cut off at the bottom of the screen
      const menuUl = Array.from(menu.children).find((child) => child.tagName === 'UL');
      menuUl.style.height = `${window.innerHeight - menuUl.getBoundingClientRect().top}px`;
      menu.classList.add('show');
      menu.classList.add('visible');
      menuObj.resetMenu();
      this.megaMenu.menus[menu.id].focusTrap.activate();
      this.megaMenu.menus[menu.id].navItems[this.megaMenu.menus[menu.id].firstFocusableElement].element.focus();
    }
  }

  hideSubMenus() {
    this.hideAllLevel3Menus();
    this.level2Menus.forEach((menu) => {
      menu.menuElement.classList.remove('show');
      menu.menuElement.previousElementSibling.setAttribute('aria-expanded', 'false');
      menu.navItems.forEach((item) => item.element.classList.remove('active'));
      menu.resetMenu();
      setTimeout(() => {
        menu.menuElement.classList.remove('visible');
      }, 200);
    });
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initGlobalNav();
});

function initGlobalNav() {
  window.globalNavElement = document.getElementById('global-nav');

  if (window.globalNavElement) {
    const globalNav = new GlobalNav(window.globalNavElement);
    console.log(globalNav);
  }
}

/** TODO this is a temp fix we will control below code behavior from aem template instead of JS */
(function () {
  const addMicrositeClass = (observer) => {
    const targetElement = document.querySelector('.micrositenav.navigation');
    if (targetElement) {
      document.body.classList.add('microsite');
      observer?.disconnect();
      return true;
    }
    return false;
  };

  if (addMicrositeClass()) return;

  document.addEventListener('DOMContentLoaded', () => {
    const mainFragment = document.querySelector('body main .experiencefragment');
    if (!mainFragment) return;

    const observer = new MutationObserver(() => addMicrositeClass(observer));
    observer.observe(mainFragment, { childList: true, subtree: true });

    addMicrositeClass(observer);
  });
})();
